import React, {useState} from 'react';
import { Link, Navigate } from "react-router-dom";
import LoginBg from '../images/lnb-logo.jpeg';
import axiosInstances from '../components/axiosInstance';

const Subscribe=()=>{

    const [msisdn, setMsisdn] = useState(''); 
    //const [sub, setSub] = useState(false)
    const [redirect, setRedirect] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const submit = async (e) =>{
        e.preventDefault();

        
        const {data} = await axiosInstances.write.post('register',{
            msisdn, 
        });
      //  console.log(data.headers)
        
        const responseCode = data.response_code
        if(responseCode === "60042"){
            setErrorMessage(data.message);
            //setSub(false);
        }
        
        if(responseCode === "0"){
           // setSub(true);
           // console.log("Is a subscriber sub:" + sub)
            setRedirect(true);
        }
        

        //console.log(data);
        
    }
    const passableParams = {
        msisdn
    }


     
    if(redirect){
        return <Navigate to={'/login'}  replace={true}  state={ passableParams } />;
    }
   
    return (
        <>
        <form onSubmit={submit}>
        <div className="bg-gray-100 flex justify-center items-center h-screen">
      
        <div className="bg-white p-8 rounded shadow-md w-80">
    <h2 className="text-2xl font-semibold mb-4">Vibes</h2>
 
      <div className="mb-4">
         
        <p>
        To subscribe send the word Vibes to 21XXX . A PIN will then be sent to your number to allow you Login
            </p>
      </div>
 
 

      <hr className="my-8" />
                {errorMessage}
                <p className="mt-4">
                    <Link
                    className="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                    to={"/login"}
                    >
                    Login
                    </Link>
                </p>
    
  </div>
          
           
        
    </div>
        </form>
         
        </>
    );
}

export default Subscribe;